<div class="mx-4 mb-5 w-fit max-w-[calc(100%-2rem)] rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-4 py-3 sm:mx-5 sm:max-w-[calc(100%-2.5rem)] sm:px-5">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Manage Application Section
    </p>

    <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
      Posts
    </h2>
  </div>
</div>

<app-manage-application-nav></app-manage-application-nav>

<ng-template #loadingTemplate>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
    <div class="flex flex-col items-center gap-4 rounded-2xl border border-gray-300 bg-white px-8 py-6">
      <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700"></div>

      <p class="text-sm font-medium text-gray-500">
        Loading posts...
      </p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!loading; else loadingTemplate">
  <main class="mt-5 px-4 pb-10 sm:px-5">

    <!-- TOOLBAR -->
    <section class="mb-5">
      <div class="grid grid-cols-12 items-center gap-4 rounded-2xl border border-gray-300 bg-white/95 p-4 backdrop-blur">

        <!-- ADD BUTTON -->
        <div class="col-span-12 md:col-span-3">
          <button
            type="button"
            class="primary-btn h-[50px] w-full rounded-xl px-5 text-sm font-semibold transition md:w-auto"
            (click)="createNewPost()"
          >
            Create New Post
          </button>
        </div>

        <!-- SEARCH + PAGINATOR -->
        <div class="col-span-12 md:col-span-9 lg:col-span-9">
          <div class="flex flex-col items-stretch gap-3 xl:flex-row xl:items-center xl:justify-end">

            <!-- SEARCH -->
            <div class="flex w-full justify-center">
              <div class="flex h-[50px] w-full max-w-md items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-300 focus-within:bg-white">

                <mat-icon class="flex-shrink-0 text-gray-400">
                  search
                </mat-icon>

                <input
                  #searchInput
                  type="text"
                  placeholder="Search..."
                  (keyup.enter)="onSearchSubmit(searchInput.value)"
                  (input)="searchValue = searchInput.value"
                  [(ngModel)]="searchValue"
                  class="min-w-0 flex-grow bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400"
                />

                <button
                  type="button"
                  (click)="clearSearch(); searchInput.value=''; searchValue=''"
                  [class.opacity-0]="!searchValue"
                  [class.pointer-events-none]="!searchValue"
                  class="ml-1 flex flex-shrink-0 items-center justify-center rounded-full p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
                >
                  <mat-icon class="cursor-pointer text-lg">
                    close
                  </mat-icon>
                </button>
              </div>
            </div>

            <!-- PAGINATOR -->
            <app-list-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageIndex]="currentPage - 1"
              [pageSizeOptions]="[12, 25, 50, 100]"
              [showFirstLastButtons]="true"
              [hidePageSize]="false"
              [disabled]="isLoading"
              (page)="onPageChange($event)"
            ></app-list-paginator>
          </div>
        </div>

      </div>
    </section>

    <!-- TABLE -->
    <section class="grid grid-cols-1 gap-4">

      <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
        <div class="w-full overflow-x-auto">

          <mat-table
            mat-table
            matSort
            [dataSource]="dataSource"
            class="!inline-table !w-full min-w-[1180px] table-fixed text-sm"
            style="border-collapse: collapse; border-spacing: 0;"
          >

            <!-- Ribbon / New -->
            <ng-container matColumnDef="new_post">
              <th mat-header-cell *matHeaderCellDef class="bg-gray-50 px-3 py-4"></th>

              <td mat-cell *matCellDef="let element" class="relative px-4 py-6">
                <div
                  class="ribbon-left absolute left-0 top-0"
                  [ngClass]="{
                    'ribbon-success': element.post_status === 'PostedOnFacebook' || element.post_status === 'PostedOnInstagram' || element.post_status === 'PostedOnTikTok',
                    'ribbon-failed': element.post_status === 'Fail' || element.post_status === 'Permanently Failed',
                    'ribbon-pending': element.post_status === 'Draft'
                  }"
                >
                </div>

                <div
                  *ngIf="isScheduledForToday(element.scheduled_for)"
                  class="pointer-events-none absolute inset-0 z-10 select-none"
                  aria-label="New: scheduled for today"
                  matTooltip="Scheduled for today"
                >
                  <div class="absolute right-0 top-0 h-12 w-12 bg-emerald-600 [clip-path:polygon(100%_0,0_0,100%_100%)]"></div>

                  <div class="absolute top-1.5 -right-6 rotate-45">
                    <span class="block whitespace-nowrap bg-emerald-600 px-6 py-1 text-center text-[10px] font-semibold uppercase tracking-wide text-white">
                      New
                    </span>
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- ID -->
            <ng-container matColumnDef="id">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                ID
              </th>

              <td mat-cell *matCellDef="let element" class="whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800">
                {{ element.id }}
              </td>
            </ng-container>

            <!-- Domain -->
            <ng-container matColumnDef="domain_name">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Domain
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-center">
                <div class="flex justify-center">
                  <ng-container *ngIf="domainSlug(element.domain_name) as slug; else noLogo">
                    <div class="h-10 w-10 overflow-hidden rounded-full ring-1 ring-gray-300">
                      <img
                        class="h-full w-full object-cover"
                        [src]="element.thumbnail_file_path"
                        (error)="onMainImgError($event)"
                      />
                    </div>
                  </ng-container>

                  <ng-template #noLogo>
                    <div class="h-10 w-10 rounded-full bg-gray-200"></div>
                  </ng-template>
                </div>
              </td>
            </ng-container>

            <!-- Title -->
            <ng-container matColumnDef="rss_title">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Title
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5">
                <div class="max-w-[500px] break-words text-sm leading-6 text-gray-800">
                  {{ element.rss_title }}
                </div>
              </td>
            </ng-container>

            <!-- Platform / Type -->
            <ng-container matColumnDef="platform_tag">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Platform / Type
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm leading-relaxed text-gray-700">
                {{ formatPlatformTag(element.social_platform_title, element.tag) }}
              </td>
            </ng-container>

            <!-- Company -->
            <ng-container matColumnDef="company">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Company
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
                {{ element.company_title || 'N/A' }}
              </td>
            </ng-container>

            <!-- Scheduled -->
            <ng-container matColumnDef="scheduled_for">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Scheduled
              </th>

              <td mat-cell *matCellDef="let element" class="whitespace-nowrap px-5 py-5 text-sm text-gray-700">
                {{ element.scheduled_for | date:'dd/MM/yyyy HH:mm' }}
              </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="post_status">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Status
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
                {{ postStatusForm(element.post_status) }}
              </td>
            </ng-container>

            <!-- Dot -->
            <ng-container matColumnDef="status_icon">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                ●
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-center">
                <span
                  class="inline-block h-4 w-4 rounded-full"
                  [ngClass]="{
                    'bg-green-500': element.post_status === 'PostedOnFacebook' || element.post_status === 'PostedOnInstagram' || element.post_status === 'PostedOnTikTok',
                    'bg-red-500': element.post_status === 'Fail' || element.post_status === 'Permanently Failed',
                    'bg-gray-300': element.post_status !== 'PostedOnFacebook' && element.post_status !== 'PostedOnInstagram' && element.post_status !== 'PostedOnTikTok' && element.post_status !== 'Fail' && element.post_status !== 'Permanently Failed'
                  }"
                >
                </span>
              </td>
            </ng-container>

            <!-- Source -->
            <ng-container matColumnDef="source">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Source
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
                {{ element.source }}
              </td>
            </ng-container>

            <!-- Repeat -->
            <ng-container matColumnDef="enable_repeat">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Repeat
              </th>

              <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm leading-relaxed text-gray-700">
                <div class="flex items-center gap-2">
                  <ng-container *ngIf="element.enable_repeat === -1; else normalRepeat">
                    <span class="italic text-gray-400">
                      Original post id: {{ element.parent_post_id }}
                    </span>
                  </ng-container>

                  <ng-template #normalRepeat>
                    <ng-container
                      *ngIf="element.post_status !== 'PostedOnInstagram' && element.post_status !== 'PostedOnFacebook'; else repeatStatus"
                    >
                      <span class="italic text-gray-400">
                        Not available
                      </span>
                    </ng-container>

                    <ng-template #repeatStatus>
                      <span [class.text-green-600]="element.enable_repeat === 1">
                        {{ element.enable_repeat === 1 ? 'Enabled' : 'Disabled' }}
                      </span>
                    </ng-template>
                  </ng-template>
                </div>
              </td>
            </ng-container>

            <!-- Rows -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="border-b border-gray-300 bg-gray-50"
            ></tr>

            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
            ></tr>

          </mat-table>

        </div>
      </div>

      <!-- EMPTY STATE -->
      <ng-container *ngIf="!isLoading && (!dataSource || dataSource.data.length === 0)">
        <div class="col-span-1 rounded-2xl border border-gray-300 bg-white px-5 py-8 text-center text-sm text-gray-400">
          No posts found.
        </div>
      </ng-container>

      <!-- BOTTOM PAGINATOR -->
      <div class="col-span-1 grid grid-cols-12 items-center rounded-2xl bg-white px-3 py-2">
        <div class="col-span-12 min-w-0 overflow-x-auto">
          <div class="grid justify-items-start sm:justify-items-end">
            <div class="w-fit min-w-max overflow-hidden rounded-xl bg-white">
              <app-list-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageIndex]="currentPage - 1"
                [pageSizeOptions]="[12, 25, 50, 100]"
                [showFirstLastButtons]="true"
                (page)="onPageChange($event)"
              >
              </app-list-paginator>
            </div>
          </div>
        </div>
      </div>

    </section>

  </main>
</ng-container>
